import React, { Component } from 'react';

export default class PreCheckout extends Component {
  render() {
    return (
      <h1>This is the pre-checkout screen</h1>
    );
  }
}
